/**
 * CygnusKnowledgeBase — Admin
 * Base de connaissance Cygnus : Documentation (.md) + Mémoire persistante.
 * Deux onglets internes.
 */

import React, { useState } from 'react';
import { BookOpen, Brain } from 'lucide-react';
import AppDocumentManagement from './AppDocumentManagement';
import CygnusMemoryManagement from './CygnusMemoryManagement';

const TABS = [
  { id: 'docs',   label: 'Documentation', icon: BookOpen },
  { id: 'memory', label: 'Mémoire',        icon: Brain },
];

const CygnusKnowledgeBase = () => {
  const [activeTab, setActiveTab] = useState('docs');

  return (
    <div>
      <div className="flex gap-1 border-b border-gray-200 px-4 sm:px-6 lg:px-8 pt-2 mb-4">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 transition-colors ${
                activeTab === t.id
                  ? 'border-indigo-500 text-indigo-700'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon size={15} />
              {t.label}
            </button>
          );
        })}
      </div>
      {activeTab === 'docs'   && <AppDocumentManagement />}
      {activeTab === 'memory' && <CygnusMemoryManagement />}
    </div>
  );
};

export default CygnusKnowledgeBase;
